/**
 * RecommendListings
 * 
 * @Author: Focci
 * @Date: 2024-06-14 15:34:04
 * @Last Modified by: Focci
 * @Last Modified time: 2024-06-14 15:34:04
 */

'use client'

// import PropTypes from 'prop-types'
import ListingCard from '@comp/page/search/listing/ListingCard'
import useTracking from '@hook/useTracking'
import { useCallback } from 'react'

export default function RecommendListings({ data, house }) {
  const { pushTrackListingClick } = useTracking()

  const onListingCardClick = useCallback(() => {
    pushTrackListingClick('more_recommend-other_house', house)
  }, [house, pushTrackListingClick])

  const customProps = { onListingCardClick }

  return data.map((item) => (
    <ListingCard
      key={item.id}
      house={{ ...item, customProps, is_feature: false }}
      favoriteTrackingPageType="collection"
    />
  ))
}

// RecommendListings.propTypes = {
//   className: PropTypes.string,
// }
